webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(2);
	
	__webpack_require__(150);
	
	__webpack_require__(139);
	
	__webpack_require__(146);
	
	var _vue = __webpack_require__(173);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(172);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _App = __webpack_require__(167);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Hello = __webpack_require__(168);
	
	var _Hello2 = _interopRequireDefault(_Hello);
	
	var _Main = __webpack_require__(169);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.player = null;
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	  history: 'true'
	});
	
	router.map({
	  '/': {
	    component: _Hello2.default
	  },
	  '/:id': {
	    component: _Main2.default
	  }
	});
	
	router.start(_App2.default, '#vue-root');

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pubnub = __webpack_require__(4);
	
	var _pubnub2 = _interopRequireDefault(_pubnub);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var list = {
	  list: [],
	  push: function push(item) {
	    this.list.push(item);
	    _pubnub2.default.postList();
	  },
	  update: function update(newList) {
	    this.list = newList;
	    _pubnub2.default.postList();
	  },
	  remove: function remove(idx) {
	    this.list.splice(idx, 1);
	    _pubnub2.default.postList();
	  }
	};
	
	exports.default = list;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _list = __webpack_require__(3);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var exp = {
	  pubnub: null,
	  userId: '',
	  channel: '',
	  connect: function connect(channel, cb) {
	    this.channel = channel;
	    this.pubnub = new PubNub({
	      publishKey: 'pub-c-734121f5-e56c-49b3-9ab5-2145cfd3887c',
	      subscribeKey: 'sub-c-0afb138a-6ca5-11e9-8724-8269f6864ada'
	    });
	    this.userId = this.pubnub.getUUID();
	    console.log('My UUID is ' + this.userId);
	
	    var that = this;
	
	    this.pubnub.addListener({
	      status: function status(statusEvent) {
	        if (statusEvent.category === 'PNConnectedCategory') {
	          console.log('connected to channel: "' + channel + '"!!!!');
	          cb();
	          that.getList();
	        }
	      },
	      message: function message(_message) {
	        that.processMsg(_message);
	      }
	    });
	
	    this.pubnub.subscribe({
	      channels: [channel]
	    });
	  },
	  processMsg: function processMsg(payload) {
	    var msg = payload.message;
	    switch (msg.action) {
	      case 'getList':
	        if (payload.publisher !== this.userId) {
	          this.postList();
	        }
	        break;
	      case 'postList':
	        if (payload.publisher !== this.userId) {
	          console.log('got list!', msg.list);
	          _list2.default.list = msg.list;
	        }
	        break;
	      case 'play':
	        console.log('got play!', msg.time);
	        player.playVideo();
	        player.seekTo(msg.time);
	        break;
	      case 'pause':
	        console.log('got pause!', msg.time);
	        if (payload.publisher !== this.userId) {
	          player.pauseVideo();
	        }
	        player.seekTo(msg.time);
	        break;
	      case 'previous':
	        console.log('got previous!');
	
	        _list2.default.list.unshift(_list2.default.list.pop());
	        player.cueVideoById(_list2.default.list[0].id, 0, 'small');
	        break;
	      case 'next':
	        console.log('got next!');
	
	        _list2.default.list.push(_list2.default.list[0]);
	        _list2.default.list.shift();
	        player.cueVideoById(_list2.default.list[0].id, 0, 'small');
	        break;
	      default:
	        console.warn('unkown action!!', msg);
	    }
	  },
	  getList: function getList() {
	    this.pubnub.publish({
	      channel: this.channel,
	      message: {
	        action: 'getList'
	      }
	    });
	  },
	  postList: function postList() {
	    this.pubnub.publish({
	      channel: this.channel,
	      message: {
	        action: 'postList',
	        list: _list2.default.list
	      }
	    });
	  },
	  sendPlay: function sendPlay(songId) {
	    this.pubnub.publish({
	      channel: this.channel,
	      message: {
	        action: 'play',
	        songId: songId,
	        time: player.getCurrentTime()
	      }
	    });
	  },
	  sendPause: function sendPause() {
	    player.pauseVideo();
	    this.pubnub.publish({
	      channel: this.channel,
	      message: {
	        action: 'pause',
	        time: player.getCurrentTime()
	      }
	    });
	  },
	  sendPrevious: function sendPrevious() {
	    this.pubnub.publish({
	      channel: this.channel,
	      message: {
	        action: 'previous'
	      }
	    });
	  },
	  sendNext: function sendNext() {
	    this.pubnub.publish({
	      channel: this.channel,
	      message: {
	        action: 'next'
	      }
	    });
	  }
	};
	
	exports.default = exp;

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(145)
	__vue_script__ = __webpack_require__(138)
	__vue_template__ = __webpack_require__(166)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 133 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      id: ''
	    };
	  },
	
	  methods: {
	    onSubmitId: function onSubmitId() {
	      console.log('submit!!!');
	
	      this.$router.go('/' + this.id.trim());
	    }
	  }
	};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pubnub = __webpack_require__(4);
	
	var _pubnub2 = _interopRequireDefault(_pubnub);
	
	var _list = __webpack_require__(3);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _PlayList = __webpack_require__(170);
	
	var _PlayList2 = _interopRequireDefault(_PlayList);
	
	var _SearchResult = __webpack_require__(171);
	
	var _SearchResult2 = _interopRequireDefault(_SearchResult);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var playerState = {
	  isPlaying: false
	};
	window.playerState = playerState;
	
	function playNext() {
	  _list2.default.list.push(_list2.default.list[0]);
	  _list2.default.list.shift();
	  player.cueVideoById(_list2.default.list[0].id, 0, 'small');
	}
	
	function onPlayerReady(event) {
	  event.target.setPlaybackQuality('small');
	  event.target.playVideo();
	  event.target.pauseVideo();
	  event.target.seekTo(0, true);
	}
	function onPlayerStateChange(e) {
	  console.log('onPlayerStateChange:', e.data);
	  playerState.isPlaying = player.getPlayerState() === 1;
	  if (e.data === 5) {
	    player.playVideo();
	    player.pauseVideo();
	    player.seekTo(0, true);
	    setTimeout(function () {
	      return _pubnub2.default.sendPlay();
	    }, 300);
	  }
	  if (e.data === 0) {
	    console.log('detected video end!');
	    playNext();
	  }
	}
	
	exports.default = {
	  name: 'Main',
	  components: {
	    'play-list': _PlayList2.default,
	    'search-result': _SearchResult2.default
	  },
	  data: function data() {
	    return {
	      connected: false,
	      list: _list2.default,
	      playerInserted: false,
	      search: '',
	      searchItems: [],
	      playerState: playerState
	    };
	  },
	
	  computed: {
	    insertYT: function insertYT() {
	      if (this.playerInserted) return;
	
	      if (this.list.list.length > 0) {
	        this.playerInserted = true;
	
	        var tag = document.createElement('script');
	
	        tag.src = 'https://www.youtube.com/iframe_api';
	        var firstScriptTag = document.getElementsByTagName('script')[0];
	        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	      }
	    },
	    playing: function playing() {
	      return playerState.isPlaying;
	    }
	  },
	  created: function created() {
	    var _this = this;
	
	    _pubnub2.default.connect(this.$route.params.id, function () {
	      _this.connected = true;
	    });
	  },
	
	  methods: {
	    play: function play() {
	      _pubnub2.default.sendPlay();
	    },
	    pause: function pause() {
	      _pubnub2.default.sendPause();
	    },
	    previous: function previous() {
	      _pubnub2.default.sendPrevious();
	    },
	    next: function next() {
	      _pubnub2.default.sendNext();
	    },
	    onSearchSubmit: function onSearchSubmit() {
	      var _this2 = this;
	
	      console.log('searching:', this.search.trim());
	      var url = 'https://www.googleapis.com/youtube/v3/search?key=AIzaSyB68Bce0y54OqqdXhVxB5kp4-u66UZphCo&part=snippet&type=video&q=' + this.search.trim();
	      $.get(url, function (data) {
	        _this2.searchItems = data.items.map(function (item) {
	          return {
	            id: item.id.videoId,
	            title: item.snippet.title,
	            description: item.snippet.description,
	            thumbnail: item.snippet.thumbnails.medium.url,
	            channelId: item.snippet.channelId,
	            channelTitle: item.snippet.channelTitle,
	            publishedAt: item.snippet.publishedAt
	          };
	        });
	      });
	    }
	  },
	  events: {
	    'on-close-search-result': function onCloseSearchResult() {
	      this.searchItems = [];
	      this.search = '';
	    }
	  }
	};
	
	
	window.onYouTubeIframeAPIReady = function onYouTubeIframeAPIReady() {
	  console.log('onYTReady, first list id:', _list2.default.list[0]);
	  window.player = new YT.Player('yt-player', {
	    height: '390',
	    width: '640',
	    videoId: _list2.default.list[0].id,
	    events: {
	      onReady: onPlayerReady,
	      onStateChange: onPlayerStateChange
	    }
	  });
	};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Song = __webpack_require__(132);
	
	var _Song2 = _interopRequireDefault(_Song);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    song: _Song2.default
	  },
	  props: ['list'],
	  data: function data() {
	    return {};
	  },
	
	  methods: {}
	};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Song = __webpack_require__(132);
	
	var _Song2 = _interopRequireDefault(_Song);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    song: _Song2.default
	  },
	  props: ['searchItems'],
	  data: function data() {
	    return {};
	  },
	
	  methods: {
	    closeSearchResult: function closeSearchResult() {
	      this.$dispatch('on-close-search-result');
	    }
	  }
	};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _list = __webpack_require__(3);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['item', 'addToPlaylistBtn', 'removeBtn', 'index'],
	  data: function data() {
	    return {};
	  },
	
	  methods: {
	    fromNow: function fromNow(a) {
	      return (0, _moment2.default)(a).fromNow();
	    },
	    addToPlayList: function addToPlayList(item) {
	      _list2.default.push(item);
	    },
	    removeFromPlayList: function removeFromPlayList(idx) {
	      _list2.default.remove(idx);
	    }
	  }
	};

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 5,
		"./af.js": 5,
		"./ar": 12,
		"./ar-dz": 6,
		"./ar-dz.js": 6,
		"./ar-kw": 7,
		"./ar-kw.js": 7,
		"./ar-ly": 8,
		"./ar-ly.js": 8,
		"./ar-ma": 9,
		"./ar-ma.js": 9,
		"./ar-sa": 10,
		"./ar-sa.js": 10,
		"./ar-tn": 11,
		"./ar-tn.js": 11,
		"./ar.js": 12,
		"./az": 13,
		"./az.js": 13,
		"./be": 14,
		"./be.js": 14,
		"./bg": 15,
		"./bg.js": 15,
		"./bm": 16,
		"./bm.js": 16,
		"./bn": 17,
		"./bn.js": 17,
		"./bo": 18,
		"./bo.js": 18,
		"./br": 19,
		"./br.js": 19,
		"./bs": 20,
		"./bs.js": 20,
		"./ca": 21,
		"./ca.js": 21,
		"./cs": 22,
		"./cs.js": 22,
		"./cv": 23,
		"./cv.js": 23,
		"./cy": 24,
		"./cy.js": 24,
		"./da": 25,
		"./da.js": 25,
		"./de": 28,
		"./de-at": 26,
		"./de-at.js": 26,
		"./de-ch": 27,
		"./de-ch.js": 27,
		"./de.js": 28,
		"./dv": 29,
		"./dv.js": 29,
		"./el": 30,
		"./el.js": 30,
		"./en-SG": 31,
		"./en-SG.js": 31,
		"./en-au": 32,
		"./en-au.js": 32,
		"./en-ca": 33,
		"./en-ca.js": 33,
		"./en-gb": 34,
		"./en-gb.js": 34,
		"./en-ie": 35,
		"./en-ie.js": 35,
		"./en-il": 36,
		"./en-il.js": 36,
		"./en-nz": 37,
		"./en-nz.js": 37,
		"./eo": 38,
		"./eo.js": 38,
		"./es": 41,
		"./es-do": 39,
		"./es-do.js": 39,
		"./es-us": 40,
		"./es-us.js": 40,
		"./es.js": 41,
		"./et": 42,
		"./et.js": 42,
		"./eu": 43,
		"./eu.js": 43,
		"./fa": 44,
		"./fa.js": 44,
		"./fi": 45,
		"./fi.js": 45,
		"./fo": 46,
		"./fo.js": 46,
		"./fr": 49,
		"./fr-ca": 47,
		"./fr-ca.js": 47,
		"./fr-ch": 48,
		"./fr-ch.js": 48,
		"./fr.js": 49,
		"./fy": 50,
		"./fy.js": 50,
		"./ga": 51,
		"./ga.js": 51,
		"./gd": 52,
		"./gd.js": 52,
		"./gl": 53,
		"./gl.js": 53,
		"./gom-latn": 54,
		"./gom-latn.js": 54,
		"./gu": 55,
		"./gu.js": 55,
		"./he": 56,
		"./he.js": 56,
		"./hi": 57,
		"./hi.js": 57,
		"./hr": 58,
		"./hr.js": 58,
		"./hu": 59,
		"./hu.js": 59,
		"./hy-am": 60,
		"./hy-am.js": 60,
		"./id": 61,
		"./id.js": 61,
		"./is": 62,
		"./is.js": 62,
		"./it": 64,
		"./it-ch": 63,
		"./it-ch.js": 63,
		"./it.js": 64,
		"./ja": 65,
		"./ja.js": 65,
		"./jv": 66,
		"./jv.js": 66,
		"./ka": 67,
		"./ka.js": 67,
		"./kk": 68,
		"./kk.js": 68,
		"./km": 69,
		"./km.js": 69,
		"./kn": 70,
		"./kn.js": 70,
		"./ko": 71,
		"./ko.js": 71,
		"./ku": 72,
		"./ku.js": 72,
		"./ky": 73,
		"./ky.js": 73,
		"./lb": 74,
		"./lb.js": 74,
		"./lo": 75,
		"./lo.js": 75,
		"./lt": 76,
		"./lt.js": 76,
		"./lv": 77,
		"./lv.js": 77,
		"./me": 78,
		"./me.js": 78,
		"./mi": 79,
		"./mi.js": 79,
		"./mk": 80,
		"./mk.js": 80,
		"./ml": 81,
		"./ml.js": 81,
		"./mn": 82,
		"./mn.js": 82,
		"./mr": 83,
		"./mr.js": 83,
		"./ms": 85,
		"./ms-my": 84,
		"./ms-my.js": 84,
		"./ms.js": 85,
		"./mt": 86,
		"./mt.js": 86,
		"./my": 87,
		"./my.js": 87,
		"./nb": 88,
		"./nb.js": 88,
		"./ne": 89,
		"./ne.js": 89,
		"./nl": 91,
		"./nl-be": 90,
		"./nl-be.js": 90,
		"./nl.js": 91,
		"./nn": 92,
		"./nn.js": 92,
		"./pa-in": 93,
		"./pa-in.js": 93,
		"./pl": 94,
		"./pl.js": 94,
		"./pt": 96,
		"./pt-br": 95,
		"./pt-br.js": 95,
		"./pt.js": 96,
		"./ro": 97,
		"./ro.js": 97,
		"./ru": 98,
		"./ru.js": 98,
		"./sd": 99,
		"./sd.js": 99,
		"./se": 100,
		"./se.js": 100,
		"./si": 101,
		"./si.js": 101,
		"./sk": 102,
		"./sk.js": 102,
		"./sl": 103,
		"./sl.js": 103,
		"./sq": 104,
		"./sq.js": 104,
		"./sr": 106,
		"./sr-cyrl": 105,
		"./sr-cyrl.js": 105,
		"./sr.js": 106,
		"./ss": 107,
		"./ss.js": 107,
		"./sv": 108,
		"./sv.js": 108,
		"./sw": 109,
		"./sw.js": 109,
		"./ta": 110,
		"./ta.js": 110,
		"./te": 111,
		"./te.js": 111,
		"./tet": 112,
		"./tet.js": 112,
		"./tg": 113,
		"./tg.js": 113,
		"./th": 114,
		"./th.js": 114,
		"./tl-ph": 115,
		"./tl-ph.js": 115,
		"./tlh": 116,
		"./tlh.js": 116,
		"./tr": 117,
		"./tr.js": 117,
		"./tzl": 118,
		"./tzl.js": 118,
		"./tzm": 120,
		"./tzm-latn": 119,
		"./tzm-latn.js": 119,
		"./tzm.js": 120,
		"./ug-cn": 121,
		"./ug-cn.js": 121,
		"./uk": 122,
		"./uk.js": 122,
		"./ur": 123,
		"./ur.js": 123,
		"./uz": 125,
		"./uz-latn": 124,
		"./uz-latn.js": 124,
		"./uz.js": 125,
		"./vi": 126,
		"./vi.js": 126,
		"./x-pseudo": 127,
		"./x-pseudo.js": 127,
		"./yo": 128,
		"./yo.js": 128,
		"./zh-cn": 129,
		"./zh-cn.js": 129,
		"./zh-hk": 130,
		"./zh-hk.js": 130,
		"./zh-tw": 131,
		"./zh-tw.js": 131
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 151;


/***/ }),
/* 152 */,
/* 153 */,
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/fontawesome-webfont.674f50d.eot";

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/fontawesome-webfont.674f50d.eot";

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/fontawesome-webfont.b06871f.ttf";

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/fontawesome-webfont.af7ae50.woff2";

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/fontawesome-webfont.fee66e7.woff";

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/fontawesome-webfont.912ec66.svg";

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "img/Music-icon.c40d5f4.png";

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	module.exports = " <div> <router-view></router-view> </div> ";

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <div id=flex-wrapper> <div id=hello> <img class=logo src=" + __webpack_require__(160) + "> <div class=hello> <h1>Welcome to ddMusic</h1> </div> <p> Enter a room id to join! </p> <form class=id-wrapper @submit.prevent=onSubmitId> <div class=input-field> <label for=id>Enter a room id, can be anything~</label> <input v-model=id class=validate id=id type=text /> </div> <div> <button class=\"btn waves-effect waves-light{{!id ? ' disabled' : ''}}\" type=submit disabled={{!id.trim()}}> Submit <i class=\"right material-icons\"> send </i> </button> </div> </form> </div> </div> ";

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	module.exports = " <div class=main-wrapper> <div v-if=!connected class=loading> <i class=\"material-icons fa fa-spin fa-refresh fa-5x\"></i> </div> <div v-else> <div class=navbar-fixed> <nav> <div class=nav-wrapper> <a href=# class=brand-logo>ddMusic</a> <div class=search-wrapper> <form @submit.prevent=onSearchSubmit> <div class=input-field> <input v-model=search type=search required> <label for=search><i class=material-icons>search</i></label> </div> </form> </div> <ul id=nav-mobile class=\"right hide-on-med-and-down\"> <li><a href=#>Home</a></li> </ul> </div> </nav> </div> <search-result :search-items=searchItems></search-result> <div v-show=list.list.length class=dummyclass{{insertYT}}> <h1>Youtube Player:</h1> <div id=yt-player></div> <div> <button @click=previous class=\"waves-effect waves-light btn\"><i class=\"fa fa-step-backward\"></i></button> <button v-if=!playing @click=play class=\"waves-effect waves-light btn\"><i class=\"fa fa-play\"></i></button> <button v-else @click=pause class=\"waves-effect waves-light btn\"><i class=\"fa fa-pause\"></i></button> <button @click=next class=\"waves-effect waves-light btn\"><i class=\"fa fa-step-forward\"></i></button> </div> </div> <play-list :list=list.list></play-list> </div> </div> ";

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	module.exports = " <div id=list-wrapper> <h2> PlayList: </h2> <ul class=container> <song v-for=\"item in list\" :item=item :remove-btn=true :index=$index></song> </ul> </div> ";

/***/ }),
/* 165 */
/***/ (function(module, exports) {

	module.exports = " <div v-if=searchItems.length id=search-result> <span class=close-search-result @click=closeSearchResult>&times;</span> <ul class=container> <song v-for=\"item in searchItems\" :item=item :add-to-playlist-btn=true></song> </ul> </div> ";

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	module.exports = " <li class=\"song card-panel\"> <img :src=item.thumbnail width=320 height=180 class=song-img /> <div class=song-right-area> <div class=song-title>{{ item.title }}</div> <button v-if=addToPlaylistBtn class=\"waves-effect waves-light btn\" @click=addToPlayList(item)>Add to playlist</button> <button v-if=removeBtn class=\"waves-effect waves-light btn\" @click=removeFromPlayList(index)>Remove</button> <div> <a href=https://www.youtube.com/channel/{{item.channelId}} target=_blank> {{ item.channelTitle }} </a> <small class=song-time>{{ fromNow(item.publishedAt) }}</small> </div> <div>{{ item.description }}</div> </div> </li> ";

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(140)
	__vue_script__ = __webpack_require__(133)
	__vue_template__ = __webpack_require__(161)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(141)
	__vue_script__ = __webpack_require__(134)
	__vue_template__ = __webpack_require__(162)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(142)
	__vue_script__ = __webpack_require__(135)
	__vue_template__ = __webpack_require__(163)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(143)
	__vue_script__ = __webpack_require__(136)
	__vue_template__ = __webpack_require__(164)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(144)
	__vue_script__ = __webpack_require__(137)
	__vue_template__ = __webpack_require__(165)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ })
]);


// WEBPACK FOOTER //
// js/app.27e09633cf15ab56b11f.js